import bellyIcon from '../../assets/icons/belly.svg';
import notificationBellIcon from '../../assets/icons/notification-bell.svg';
import notificationBellReadIcon from '../../assets/icons/notification-bell-read.png';
import { useNavigate } from 'react-router';

function PlaygroundTopHeader({ showRedDot = false }) {
  const navigate = useNavigate();

  return (
    <div className="flex h-9 w-full items-center justify-between px-4 py-8">
      <div className="justify-center text-white text-[1.4375rem] font-extrabold font-['Pretendard'] [text-shadow:_0px_0px_16px_rgb(139_104_221_/_0.80)]">
        야옹상회
      </div>

      <div className="Container inline-flex items-center justify-start gap-2.5">
        <div
          className="pool-pill-pulse flex h-9 w-28 cursor-pointer items-center justify-center gap-1.5 rounded-[30px] bg-[#ffeb3b] px-3 py-1.5"
          onClick={() => navigate('/pool')}
        >
          <div data-layer="pool" className="Pool relative">
            <img src={bellyIcon} alt="히든밸리 아이콘" className="mt-1 h-6 w-6 brightness-0" />
          </div>
          <div
            data-layer="히든밸리"
            className="justify-center font-['Pretendard'] text-sm font-extrabold text-black"
          >
            히든밸리
          </div>
        </div>

        <div
          className="Container relative cursor-pointer"
          onClick={() => navigate('/notifications')}
        >
          {showRedDot ? (
            <>
              <img src={notificationBellIcon} alt="알림" className="h-6 w-6" />
              <span
                className="absolute right-[3px] top-[-1px] h-2 w-2 rounded-full bg-[#F6475F]"
                aria-hidden="true"
              />
            </>
          ) : (
            <img src={notificationBellReadIcon} alt="알림 없음" className="h-6 w-6 object-contain" />
          )}
        </div>
      </div>
    </div>
  );
}

export default PlaygroundTopHeader;
